module.exports = __webpack_public_path__ + "img/service.5e10c71f.png";